@if (initialized) {
    <div class="cn-model-comparison-container surface-0">

        <!-- Two tabs: the existing forward simulation (default) and the Ist-anchored Soll/Ist-Abgleich.
             The default tab is "Forecast" so the existing flow is unchanged; ?tab=abgleich selects the
             second tab (set by the Abgleich page navigation + "Modell-Vergleich" header link). -->
        <p-tabs [value]="activeTab">
            <p-tablist>
                <p-tab [value]="0">Forecast</p-tab>
                <p-tab [value]="1">Soll/Ist-Abgleich</p-tab>
            </p-tablist>
            <p-tabpanels>

                <!-- Tab 0: existing forecast simulation — unchanged. -->
                <p-tabpanel [value]="0">
                    <mvs-cn-model-comparison></mvs-cn-model-comparison>
                </p-tabpanel>

                <!-- Tab 1: Ist-anchored Soll/Ist-Abgleich, fed by the query-param selection. -->
                <p-tabpanel [value]="1">
                    <mvs-cn-abgleich-comparison
                            [statementId]="abgleichStatementId"
                            [activeModelId]="abgleichActiveModelId"
                            [horizonYears]="abgleichHorizonYears"
                            [scenarioModelIds]="abgleichScenarioModelIds">
                    </mvs-cn-abgleich-comparison>
                </p-tabpanel>

            </p-tabpanels>
        </p-tabs>

    </div>
}
